/**
 * Shared by the dialog's semantic search and the build script that embeds its
 * index (no browser-only imports here: the script runs in Node). The model and
 * dimensions must match the `page-info-embed` Edge Function
 * (franklin-data-pipeline, supabase/functions/_shared/page-info-embed.ts).
 */
/** Must match the Edge Function's model and dimensions (it echoes both back). */
export const PAGE_INFO_EMBED_MODEL = "text-embedding-3-large";
export const PAGE_INFO_EMBED_DIMENSIONS = 1024;
export const PAGE_INFO_EMBED_FUNCTION = "page-info-embed";
/** The function refuses longer input. */
export const PAGE_INFO_MAX_QUERY_CHARS = 200;

export interface PageInfoIndexFile {
  model: string;
  dimensions: number;
  /**
   * Similarity an off-topic query typically reaches against this index (the
   * build script's 80th percentile over a fixed set of unrelated queries).
   * Per language, because Estonian scores run higher across the board.
   */
  noiseFloor: number;
  /** `page.item` → the hash of the chunk text embedded, and its int8 vector, base64. */
  chunks: Record<string, { hash: string; v: string }>;
}
